module.exports = __webpack_public_path__ + "static/media/I1.1e87f281.png";